import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material';

const TaxExemptionSection = ({ control, errors, pricingEngine, resetField, getValues }) => {
  const [showFields, setShowFields] = useState(false);

  useEffect(() => {
    const taxExemptionValues = getValues('tax_exemption');
    if (taxExemptionValues && taxExemptionValues.amount > 0) {
      setShowFields(true);
    }
  }, [getValues]);

  const handleRemove = () => {
    resetField('tax_exemption.amount', { defaultValue: 0 });
    resetField('tax_exemption.tax', { defaultValue: 0 });
    resetField('tax_exemption.reason', { defaultValue: '' });

    setShowFields(false);
  };

  return (
    <>
      {!showFields ? (
        <>
          <Divider sx={{ mt: 2 }} />
          <Button variant="contained" color="primary" onClick={() => setShowFields(true)} sx={{ mt: 2 }}>
            Add Tax Exemption
          </Button>
        </>
      ) : (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
            <Typography variant="h6">Tax Exemption</Typography>
            <Button variant="text" color="error" onClick={handleRemove}>
              Remove
            </Button>
          </Box>
          <Divider sx={{ mt: 1, mb: 2 }} />
          <Grid container spacing={2}>
            <Grid size={6}>
              <Controller
                name="tax_exemption.amount"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Amount Exempted From Tax"
                    variant="outlined"
                    fullWidth
                    type="number"
                    error={!!errors.tax_exemption?.amount || !!errors.tax_exemption?.root}
                    helperText={errors.tax_exemption?.amount?.message || errors.tax_exemption?.root?.message}
                    onChange={(event) => {
                      const inputValue = event.target.value;
                      const regex = /^\d*\.?\d{0,2}$/;
                      if (regex.test(inputValue) || inputValue === '') {
                        field.onChange(inputValue === '' ? 0 : inputValue);
                      }
                    }}
                    onBlur={(event) => {
                      const value = event.target.value;
                      if (!value) {
                        field.onChange(0);
                      }
                    }}
                  />
                )}
              />
            </Grid>
            <Grid size={6}>
              <Controller
                name="tax_exemption.tax"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    value={pricingEngine.tax_exemption?.tax || 0}
                    label="Amount of Tax Exemption"
                    variant="outlined"
                    fullWidth
                    InputProps={{ readOnly: true }}
                    error={!!errors.tax_exemption?.tax}
                    helperText={errors.tax_exemption?.tax?.message}
                  />
                )}
              />
            </Grid>
            <Grid size={12}>
              <Controller
                name="tax_exemption.reason"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Reason of Tax Exemption"
                    variant="outlined"
                    fullWidth
                    error={!!errors.tax_exemption?.reason}
                    helperText={errors.tax_exemption?.reason?.message}
                  />
                )}
              />
            </Grid>
          </Grid>
        </>
      )}
    </>
  );
};

export default TaxExemptionSection;
